import {IconType} from '../../../../design-system/atoms/Icon/IconType.enum';
import {CategoryType} from '../../../../graphql/generated/types';

export function getCategoryIcon(categoryType?: CategoryType) {
  return categoryType === CategoryType.KatalkNovel
    ? IconType.ContentHomeChat
    : categoryType === CategoryType.Book
      ? IconType.ContentHomeBook
      : categoryType === CategoryType.Webnovel
        ? IconType.ContentHomeNovel
        : IconType.ContentHomeComic;
}
